export default "__VITE_ASSET__rTEPrONb__"